'use client';

const defaultProps = {
  inputSpacing: "md"
};
export {
  defaultProps
};
